import { nextTick } from 'vue';
import {
    createMemoryHistory,
    createRouter,
    createWebHashHistory,
    createWebHistory,
    isNavigationFailure,
    NavigationFailureType
} from 'vue-router';

import { posthog } from '@boot/posthog';

import routes from './routes';

/**
 * Registering the push attribute of router globally
 * to catch the errors if any.
 */

export default function (/* { store, ssrContext } */) {
    const createHistory = process.env.SERVER
        ? createMemoryHistory
        : process.env.VUE_ROUTER_MODE === 'history'
          ? createWebHistory
          : createWebHashHistory;

    const Router = createRouter({
        scrollBehavior: function (to, from, savedPosition) {
            if (to.hash) {
                return { el: to.hash };
            } else {
                return { x: 0, y: 0 };
            }
        },
        routes,

        // Leave this as is and make changes in quasar.config.js instead!
        // quasar.config.js -> build -> vueRouterMode
        // quasar.config.js -> build -> publicPath
        history: createHistory(
            process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
        )
    });

    /**
     * Registering the push attribute of router globally
     * to catch the errors if any.
     */
    const originalPush = Router.push;
    Router.push = function push(location, onResolve, onReject) {
        if (onResolve || onReject) {
            return originalPush.call(this, location, onResolve, onReject);
        }
        return originalPush.call(this, location).catch(err => {
            if (
                isNavigationFailure(err, NavigationFailureType.redirected) ||
                isNavigationFailure(err, NavigationFailureType.cancelled) ||
                isNavigationFailure(err, NavigationFailureType.duplicated)
            ) {
                return err;
            }
            return Promise.reject(new Error(err));
        });
    };

    Router.afterEach((to, from, failure) => {
        console.debug(`Navigating to ${to.fullPath}`);
        if (!failure) {
            nextTick(() => {
                try {
                    posthog.capture('$pageview', {
                        $current_url: to.fullPath
                    });
                } catch (e) {
                    console.error(e);
                }
            });
        }
    });

    return Router;
}
